import { html } from "lit";
import type { Meta, StoryObj } from "@storybook/web-components";

interface DynamicInputProps {
    addText: string;
    inputName: string;
    initItems: number;
    minItems: number;
    maxItems: number;
    prefilledValues: string[];
    disabled: boolean;
    regex: string;
    errorMessage: string;
}

const meta = {
    title: "Utils/Dynamic Input",
    component: "mf-dynamic-input",
    argTypes: {
        addText: {
            control: "text",
            description: "Text for the button to add another input"
        },
        inputName: {
            control: "text",
            description: "Name attribute for the input fields, will be suffixed with a number"
        },
        initItems: {
            control: "number",
            description: "Initial number of input fields to display"
        },
        minItems: {
            control: "number",
            description: "Minimum number of input fields that must be displayed"
        },
        maxItems: {
            control: "number",
            description: "Maximum number of input fields that can be displayed"
        },
        prefilledValues: {
            control: "object",
            description: "array of prefilled values for the input fields"
        },
        disabled: {
            control: "boolean",
            description: "Disable the input fields and delete button"
        },
        regex: {
            control: "text",
            description: "Regular expression to validate the input values"
        },
        errorMessage: {
            control: "text",
            description: "Error message to display for invalid input values"
        }
    },
    render: (args) =>
        html`<service-calls-dynamic-input
            add-text="${args.addText}"
            input-name="${args.inputName}"
            init-items="${args.initItems}"
            min-items="${args.minItems}"
            max-items="${args.maxItems}"
            .prefilledValues=${args.prefilledValues}
            ?disabled=${args.disabled}
            regex="${args.regex}"
            error-message="${args.errorMessage}"
        ></service-calls-dynamic-input>`
} satisfies Meta<DynamicInputProps>;

export default meta;

export const Default: StoryObj<DynamicInputProps> = {
    args: {
        addText: "Add another input",
        inputName: "dynamic-input",
        initItems: 1,
        minItems: 1,
        maxItems: 5,
        prefilledValues: ["Value 1"],
        disabled: false,
        regex: "/^[0-9]+$/",
        errorMessage: "Please enter a valid error number"
    }
};

export const Validation: StoryObj<DynamicInputProps> = {
    args: {
        addText: "Add another input",
        inputName: "dynamic-input",
        initItems: 1,
        minItems: 1,
        maxItems: 5,
        prefilledValues: ["12345"],
        disabled: false,
        regex: "^[0-9]+$",
        errorMessage: "Please enter a valid error number"
    },
    render: (args) =>
        html`<ux-form>
            <form>
                <service-calls-dynamic-input
                    add-text="${args.addText}"
                    input-name="${args.inputName}"
                    init-items="${args.initItems}"
                    min-items="${args.minItems}"
                    max-items="${args.maxItems}"
                    .prefilledValues=${args.prefilledValues}
                    ?disabled=${args.disabled}
                    regex="${args.regex}"
                    error-message="${args.errorMessage}"
                ></service-calls-dynamic-input>
                <ux-button type="submit">Submit</ux-button>
            </form>
        </ux-form>`
};
